import React from 'react'
import "./AddResultBtn.css"
import addBtn from "../../assets/images/svg/addbtn.svg"

const AddResultBtn = ({translations}) => {
    return (
        <button className='add-result'>
        <img src={addBtn} />
        {translations?.message?.addResultToFolder ? translations.message.addResultToFolder : "Add This Results to Folder"} 
        </button>
    )
}

export default AddResultBtn
